import { render } from "./DetailBank.vue?vue&type=template&id=11afba60"
import script from "./DetailBank.vue?vue&type=script&lang=js"
export * from "./DetailBank.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__